import { HttpMethods, getRequestApiUrl, getApiRequestHeaders, sendRequest, sendRequestWithOptions } from "../util/ApiHelper";

const CONTROLLER_NAME = "Documents";
const SECURITY_CONTROLLER_NAME = "Security";

export interface DocumentData {
    DocContentBase64?: string;
    Filename?: string;
    FileModifiedDate?: string;
    Tags?: string[];
    ContentType?: string;
    FilePath?: string;
};

export const uploadDocument = async (data: DocumentData) => {
    return await sendRequest(
        HttpMethods.POST,
        `${CONTROLLER_NAME}/Post`,
        data,
        {}
    );
};

export const getPreSignedUploadUrl = async (filename: string) => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetPreSignedUploadUrl`,
        {},
        {
            filename: filename,
        }
    );
};

export const scanAndUploadDocument = async (data: DocumentData) => {
    return await sendRequest(
        HttpMethods.POST,
        `${CONTROLLER_NAME}/UploadDocument`,
        data,
        {}
    );
};

export interface LinkDocToWorkOrderData {
    DocId: string;
    PrintWithWoFlag: boolean;
    WoNumber: string;
    ProviderId: number;
}

export const linkDocToWorkOrder = async (data: LinkDocToWorkOrderData) => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/LinkDocToWorkOrder`,
        {},
        {
            docId: data.DocId,
            printWithWoFlag: String(data.PrintWithWoFlag),
            woNumber: data.WoNumber,
            providerId: String(data.ProviderId)
        }
    );
};

export const downloadDocument = async (downloadUrl: string) => {
    return await sendRequestWithOptions(
        HttpMethods.GET,
        {
            url: await getRequestApiUrl(downloadUrl),
            headers: await getApiRequestHeaders(),
            responseType: "blob"
        }
    );
};

export const getSsoTokenCurrentSession = async () => {
    return sendRequest(
        HttpMethods.GET,
        `${SECURITY_CONTROLLER_NAME}/GetSsoTokenCurrentSession`,
        {},
        {
            encryptToken: true
        }
    );
};
